<template>
  <div class="flex-column a-center j-center bg-white">
    <span class="ai-animate main-txt" swiper-animate-effect="fadeInDown" swiper-animate-speed="1_5">专注学生的个性化问题</span>
    <div class="flex a-center j-between m-b-80" v-if="detectedInfos.isPC">
      <img class="ai-animate w-400 m-r-80" swiper-animate-effect="fadeInLeft" swiper-animate-delay="0_5" swiper-animate-speed="1_5" src="../assets/module-3-1.png">
      <span class="ai-animate sub-txt text-right w-400" swiper-animate-effect="fadeInRight" swiper-animate-delay="0_5" swiper-animate-speed="1_5">
        <span class="text-blue">外研优学</span>，为每位孩子提供多维诊断报告和专属学习方案，
        因材施教，远离题海战术，高效快速达到目标，不走弯路
      </span>
    </div>
    <div class="flex a-center j-between" v-if="detectedInfos.isPC">
      <span class="ai-animate sub-txt text-left w-400 m-r-80" swiper-animate-effect="fadeInLeft" swiper-animate-delay="1_5" swiper-animate-speed="1_5">
        <span class="text-blue">练习题</span> - 八维知识图谱标注，和烂题说bye-bye。<br>
        <span class="text-blue">过程性训练</span> - 特别设计的过程性训练，照顾孩子的不同水平，练习效果立竿见影。<br>
        <span class="text-blue">精品课程</span> - 更有精品课程，针对中考易错重点、难点问题，由一线名师细致讲解，让孩子成绩轻松up up up。
      </span>
      <img class="ai-animate w-400" swiper-animate-effect="fadeInRight" swiper-animate-delay="1_5" swiper-animate-speed="1_5" src="../assets/module-3-2.png">
    </div>
    <div class="a-center j-between mobiles" v-if="!detectedInfos.isPC">
      <img class="ai-animate" swiper-animate-effect="fadeInLeft" swiper-animate-delay="0_5" swiper-animate-speed="1_5" src="../assets/module-3-1.png">
      <span class="ai-animate sub-txt" swiper-animate-effect="fadeInRight" swiper-animate-delay="0_5" swiper-animate-speed="1_5">
        <span class="text-blue">外研优学</span>，为每位孩子提供多维诊断报告和专属学习方案，
        因材施教，远离题海战术，高效快速达到目标，不走弯路
      </span>
    </div>
    <div class="a-center j-between mobiles mobiles-b" v-if="!detectedInfos.isPC">
      <img class="ai-animate w-400" swiper-animate-effect="fadeInRight" swiper-animate-delay="1_5" swiper-animate-speed="1_5" src="../assets/module-3-2.png">
      <span class="ai-animate sub-txt text-left w-400 m-r-80" swiper-animate-effect="fadeInLeft" swiper-animate-delay="1_5" swiper-animate-speed="1_5">
        <span class="text-blue">练习题</span> - 八维知识图谱标注，和烂题说bye-bye。<br>
        <span class="text-blue">过程性训练</span> - 特别设计的过程性训练，照顾孩子的不同水平，练习效果立竿见影。<br>
        <span class="text-blue">精品课程</span> - 更有精品课程，针对中考易错重点、难点问题，由一线名师细致讲解，让孩子成绩轻松up up up。
      </span>
    </div>
  </div>
</template>
<script>
import detectedInfos from "../utils/mobile"
export default {
  data() {
    return {
      detectedInfos
    }
  }
}
</script>

<style lang="scss" scoped>
.main-txt {
  font-size: 36px;
  font-weight: 500;
  margin-bottom: 28px;
}

.w-550 {
  width: 550px;
}

.sub-txt {
  font-size: 18px;
  font-weight: 400;
  line-height: 40px;
}
@media (max-width: 1024px) {
  .w-400{
    width: 330px;
  }
  .m-r-80{
    margin-right: 20px;
  }
}
@media (max-width: 767px) {
  .main-txt {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 0px;
    // margin-top: 10px;
  }
  .mobiles {
    padding: 0 20px;
    margin-bottom: 10px;
    // width: 300px;
    img {
      width: 64%;
      margin: auto;
      display: block;
    }
    .sub-txt {
      font-size: 12px;
      line-height: 20px;
    }
  }
  .mobiles-b{
    margin-bottom: 30px;
  }
}
</style>
